import Icon from '@ant-design/icons/lib/components/Icon';
import { Select, SelectProps } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

export const svgIcon = (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.93945 0.32959L4.7197 3.54934L1.49995 0.32959L0.439453 1.39009L4.7197 5.67034L8.99995 1.39009L7.93945 0.32959Z"
      fill="#828D9E"
    />
  </svg>
);
export const formatterStr = (str: string) =>
  str ? str.replace(/\s*/g, '') : '';

const ZeissSelect = (
  props: SelectProps & { arrowEvent?: boolean; suffixText?: string }
): any => {
  const { t } = useTranslation();
  const { fieldNames } = props;
  const [suffixIcon, setSuffixIcon] = useState<ReactNode>(
    props.suffixText ? (
      <div className="normal-flex">
        <div className="pc-suffixText">{props.suffixText}</div>
        <Icon component={() => svgIcon} />
      </div>
    ) : (
      <Icon component={() => svgIcon} />
    )
  );
  useEffect(() => {
    if (props.suffixIcon) {
      setSuffixIcon(props.suffixIcon);
    }
  }, []);

  return (
    <Select
      {...props}
      className={`${props.className ?? ''} zeiss-reset-select`}
      placeholder={props.placeholder || t('component.select.placeholder')}
      suffixIcon={suffixIcon}
      showSearch
      filterOption={(input, option) => {
        const values = fieldNames
          ? option?.[fieldNames.label as string]
          : option?.label;
        return ((formatterStr(values) ?? '') as string)
          .toLowerCase()
          .includes(formatterStr(input).toLowerCase());
      }}
    />
  );
};

ZeissSelect.OptGroup = Select.OptGroup;
ZeissSelect.Option = Select.Option;

export default ZeissSelect;
